import { render, staticRenderFns } from "./RegisterStatistical.vue?vue&type=template&id=61f42bea&scoped=true&"
import script from "./RegisterStatistical.vue?vue&type=script&lang=js&"
export * from "./RegisterStatistical.vue?vue&type=script&lang=js&"
import style0 from "./RegisterStatistical.vue?vue&type=style&index=0&id=61f42bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f42bea",
  null
  
)

export default component.exports